import apiClient from "../client";

// GET /api/master-data-links
export const getMasterDataLinks = async () => {
  const response = await apiClient.get("/master-data-links");
  return response.data;
};

// POST /api/master-data-links
export const createMasterDataLink = async (body) => {
  const response = await apiClient.post("/master-data-links", body);
  return response.data;
};

// PUT /api/master-data-links/{id}
export const updateMasterDataLink = async (linkId, body) => {
  const response = await apiClient.put(`/master-data-links/${linkId}`, body);
  return response.data;
};

// DELETE /api/master-data-links/{id}
export const deleteMasterDataLink = async (linkId) => {
  const response = await apiClient.delete(`/master-data-links/${linkId}`);
  return response.data;
};
